import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import UserProfile from "../Pages/Authentication/user-profile";

// Import Authentication Inner Pages
import Login1 from "../Pages/AuthenticationPages/Login";
import RecoverPassword from "../Pages/AuthenticationPages/RecoverPassword";
import LockScreen from "../Pages/AuthenticationPages/LockScreen";

// Import Utility Pages
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

import SubDistributer from "../Pages/SubDistributer/index";
import CapitalInvestment from "../Pages/CapitalInvestment/index";
import Account from "../Pages/CapitalInvestment/Account";
import Customer from "../Pages/Customer/index";
import CustomerAdd from "../Pages/Customer/Add";
import Deposit from "../Pages/Deposit/index";
import Expenses from "../Pages/Expenses/index";
import TermsCondition from "../Pages/Settings/TermsCondition";
const userData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },

  //admin
  { path: "/sub-distributor", component: <SubDistributer />, isAllowed: userData?.role === "distributor" },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },
  { path: "/terms-condition", component: <TermsCondition />, isAllowed: userData?.role === "distributor" },

  //capital investment
  { path: "/record-book", component: <CapitalInvestment /> },
  { path: "/account/:id", component: <Account /> },

  //customer management
  { path: "/customer", component: <Customer /> },
  { path: "/customer/add", component: <CustomerAdd /> },
  { path: "/customer/edit/:id", component: <CustomerAdd /> },
  { path: "/customer/view/:id", component: <CustomerAdd /> },

  //deposit management
  { path: "/deposit", component: <Deposit /> },

  //expenses
  { path: "/expenses", component: <Expenses /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password/:token", component: <ForgetPasswordPage /> },

  // Authentication Inner Pages
  { path: "/auth-login", component: <Login1 /> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },

  // Utility Pages
  { path: "*", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
